// Day / night / system theme. Stored per browser; applied as data-theme on the root so the CSS tokens switch.
import React from 'react';
export type Theme = 'light' | 'dark' | 'system';
const KEY = 'leo.theme';
export const readTheme = (): Theme => { try { const v = localStorage.getItem(KEY); return v === 'light' || v === 'dark' ? v : 'system'; } catch { return 'system'; } };
export function applyTheme(t: Theme) { const root = document.documentElement; if (t === 'system') root.removeAttribute('data-theme'); else root.setAttribute('data-theme', t); try { localStorage.setItem(KEY, t); } catch { /* per-browser convenience only */ } }
export function ThemeSwitch() {
  const [t, setT] = React.useState<Theme>(readTheme);
  React.useEffect(() => { applyTheme(t); }, [t]);
  return (
    <div className="theme" role="group" aria-label="Theme">
      {(['light', 'dark', 'system'] as Theme[]).map(x => <button key={x} className={t === x ? 'on' : ''} onClick={() => setT(x)} title={x === 'system' ? 'Follow the device' : x === 'dark' ? 'Night' : 'Day'}>{x === 'light' ? '☀' : x === 'dark' ? '☾' : 'Auto'}</button>)}
    </div>
  );
}
